import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material"
import { DatePicker } from "antd"
import dayjs from "dayjs"
const { RangePicker } = DatePicker

export default function TimePeriodSelector({
  value,
  customValue,
  onChange,
  onChangeCustom,
  startDate,
  endDate,
}: {
  value: string | null
  onChange: (value: string) => void
  customValue: [any, any]
  onChangeCustom: (value: [any, any]) => void
  startDate?: string
  endDate?: string
}) {
  return (
    <Box sx={{ display: "flex", gap: "16px" }}>
      <RangePicker
        value={[
          startDate && dayjs(startDate),
          endDate && dayjs(endDate),
        ]}
        onChange={onChangeCustom}
      />
      <ToggleButtonGroup
        exclusive
        value={value}
        sx={{ "& button": { textTransform: "none" } }}
        onChange={(event, value) => {
          // Don't allow deselecting option
          if (value !== null) {
            onChange(value)
          }
        }}
      >
        <ToggleButton value="today">Today</ToggleButton>
        <ToggleButton value="this-week">This week</ToggleButton>
        <ToggleButton value="this-month">This month</ToggleButton>
        <ToggleButton value="this-quarter">This quarter</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )
}
